export default __webpack_public_path__ + "static/media/agent.45c89f7e.png";